/**
 * Wrapper defensivo sobre window.localStorage.
 *
 * Resuelve dos fallos observados en producción:
 *  1) `QuotaExceededError` al hacer setItem cuando el almacenamiento está lleno.
 *  2) `null is not an object (evaluating 'localStorage.getItem')` cuando
 *     localStorage no está disponible (modo privado, cookies bloqueadas,
 *     storage particionado en iframes, etc.).
 *
 * Todas las operaciones son seguras: nunca lanzan excepción. Si el
 * almacenamiento no está disponible o la operación falla, se degradan
 * de forma silenciosa devolviendo un valor por defecto.
 */

const isAvailable = () => {
  try {
    return typeof window !== 'undefined' && window.localStorage !== null && typeof window.localStorage !== 'undefined';
  } catch (err) {
    // Acceder a window.localStorage puede lanzar SecurityError en algunos navegadores.
    return false;
  }
};

const safeLocalStorage = {

  getItem: (key) => {
    if (!isAvailable()) return null;
    try {
      return window.localStorage.getItem(key);
    } catch (err) {
      return null;
    }
  },

  setItem: (key, value) => {
    if (!isAvailable()) return false;
    try {
      window.localStorage.setItem(key, value);
      return true;
    } catch (err) {
      // QuotaExceededError u otros: no interrumpe el flujo de la app.
      return false;
    }
  },

  removeItem: (key) => {
    if (!isAvailable()) return false;
    try {
      window.localStorage.removeItem(key);
      return true;
    } catch (err) {
      return false;
    }
  },

};

export default safeLocalStorage;
